import { InjectionToken } from '@angular/core';
import { ComponentType } from '@angular/cdk/overlay';
// eslint-disable-next-line
import {LowResolutionComponent} from '../components/low-resolution/low-resolution.component';

// injection token to avoid circular dependencies
/*eslint-disable*/
export const LOW_RESOLUTION_COMPONENT: InjectionToken<ComponentType<LowResolutionComponent>> = new InjectionToken<ComponentType<LowResolutionComponent>>('LOW_RESOLUTION_COMPONENT');
